import { ENV } from './env';

// eslint-disable-next-line import/no-anonymous-default-export, import/no-default-export
export default {
  environment: 'production',
  demoBackendUrl: `${ENV.VITE_API_URL}`,
  onboarding: {
    baseUrl: 'https://studio.speechify.com/onboarding?src=studio-demo',
  },
  static: {
    public_base_url: 'https://cdn.speechify.com/voiceover-demo',
  },
  swsApiBaseUrl: 'https://api.sws.speechify.com',
};
